export default {
  initPortletId: ({ commit }, portletId) => {
    commit("INIT_PORTLET_ID", portletId);
  },
  setActiveMapButton: ({commit}, id) =>{
    commit("SET_ACTIVE_MAP_BUTTON", id)
  },
  setStreetView: ({ commit }, streetviewStatus) => {
    commit("SET_STREETVIEW", streetviewStatus);
  },
  setTime: ({ commit }, time) => {
    commit("SET_TIME", time);
  },
  setZoomState: ({commit}, newZoomState) =>{
    commit("SET_ZOOM_STATE", newZoomState);
  },
  SideNavigationWideOpen: ({ commit }) => {
    commit("WIDE_ASIDE_PANEL_OPEN");
  },
  SideNavigationWideClose: ({ commit }) => {
    commit("WIDE_ASIDE_PANEL_CLOSE");
  },
  setComponentSelectionDropdownOpen: ({ commit }, value) => {
    commit("SET_COMPONENT_SELECTION_DROPDOWN_OPEN", value);
  },
  setEscClicked: ({ commit }, value) => {
    commit("SET_ESC_CLICKED", value);
  },
};
